// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetProjectsListRequest,
  TGetProjectsListModel,
  IMappers,
  TGetProjectsListResponse,
  IGetProjectsListResponse,
  IGetProjectsListResponseError,
} from './types';

export const defaultConfig: TGetProjectsListModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'countryside-constructors',
  pathApi: '/v1/get-projects-list/',
} as TGetProjectsListModel;

export function createGetProjectsListModel(parameters: IGetProjectsListRequest): TGetProjectsListModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetProjectsListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetProjectsListRequest;
}

export async function fetchGetProjectsList<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetProjectsListOptions<TResponse200, TResponse400>): Promise<
  TGetProjectsListResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetProjectsListModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetProjectsListResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetProjectsListResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetProjectsListResponse;
}
